import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import React from "react";

const SSPCommonVideo = ({ videoUrl, headerText }) => {
  return (
    <Card
      sx={{
        backgroundColor: "#EEF2F7",
        padding: "1.3rem",
      }}
    >
      <CardHeader
        p={2}
        sx={{
          backgroundColor: "#F8F8F9",
          fontWeight: "700",
          borderTopRightRadius: "5px",
          borderTopLeftRadius: "5px",
        }}
        title={headerText}
        titleTypographyProps={{
          sx: {
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "16px",
            color: "#0160F1",
          },
        }}
      />
      <Divider />
      <CardContent
        sx={{
          backgroundColor: "#FFFFFF",
          borderBottomRightRadius: "5px",
          borderBottomLeftRadius: "5px",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
        }}
      >
        <iframe
          width="560"
          height="315"
          src={videoUrl}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </CardContent>
    </Card>
  );
};

export default SSPCommonVideo;
